import { useMemo, useState } from "react";
import PageLayout from "@/components/layouts/page/PageLayout";
import { Typography } from "@mui/material";
import EmailCampaignReport from "../components/campaign-report/EmailCampaignReport";
import LocationFilter from "../components/common/LocationFilter";
import { emailCampaigns } from "../utils/emailCampaignsDummyData";

type EmailReportLocation = {
  id: number;
  name: string;
};

function EmailCampaignReportPage() {
  const uniqueLocations = useMemo(() => {
    const allLocations = emailCampaigns.flatMap(
      (campaign) => campaign.locations
    );
    return allLocations.filter(
      (location, index, self) =>
        index === self.findIndex((l) => l.id === location.id)
    );
  }, []);

  const [selectedLocation, setSelectedLocation] = useState(
    uniqueLocations[0]?.id
  );

  const handleLocationChange = (location?: EmailReportLocation) => {
    setSelectedLocation(location?.id);
  };

  return (
    <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
      <div className="row align-items-center mb-4">
        <div className="col-12 col-md-4">
          <Typography variant="h5" className="widget-title mb-0">
            Email Campaign Reports
          </Typography>
        </div>
        <div className="col-12 col-md-8">
          <div className="d-flex justify-content-end mt-4 mt-md-0">
            <LocationFilter
              locations={uniqueLocations}
              selectedLocation={selectedLocation}
              onLocationChange={handleLocationChange}
              label="Select Location"
              className="col-12 col-sm-12 col-md-4 p-0"
            />
          </div>
        </div>
      </div>
      <EmailCampaignReport selectedLocation={selectedLocation} />
    </PageLayout>
  );
}

export default EmailCampaignReportPage;
